module.exports = __webpack_public_path__ + "img/2.859d6973.png";